import { makeStyles } from '@material-ui/core';
import { calculateHeight, calculateWidth, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

interface RecallOrderStyleProps {
  leftHanded?: boolean;
}

const vSpace = calculateHeight(14).stringValue;
const hSpace = calculateWidth(14).stringValue;
export const styles = makeStyles(() => ({
  background: {
    backgroundColor: themeColor.lightBackground,
    padding: `${vSpace} 0`,
  },
  displayBody: {
    flex: '1 1 auto',
    padding: `0 ${hSpace}`,
  },
  recallOrderLabel: {
    fontSize: vh(3.12),
    fontWeight: 500,
    lineHeight: '3.62vh',
    letterSpacing: 1,
    color: themeColor.defaultTextColor,
  },
  bottomContainer: {
    marginTop: 'auto',
    width: '100%',
  },
  paginationContainer: {
    marginRight: 'auto',
  },
  recallButton: {
    fontSize: vh(2.08),
  },
  switchButton: {
    fontSize: vh(2.08),
    margin: `0 ${hSpace}`,
  },
  keypadContainer: ({ leftHanded }: RecallOrderStyleProps) => ({
    flex: '0 0 auto',
    margin: 0,
    [leftHanded ? 'marginLeft' : 'marginRight']: hSpace,
    alignSelf: 'flex-end',
  }),
  keypadButton: ({ leftHanded }: RecallOrderStyleProps) => ({
    margin: 0,
    [leftHanded ? 'marginRight' : 'marginLeft']: hSpace,
  }),
  listScrollWrapper: {
    // hint = ~14px (just to show the that there is a next item)
    // height = items * (itemheight + itemMargin) + hint
    height: calculateHeight(5 * (60 + 12) + 14).stringValue,
    marginTop: '2.6vh',
    '@media (aspect-ratio: 16/9) and (max-width: 1024px)': {
      marginTop: '2vh',
    },
  },
}));
